/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.Aks.PersonenAks
 * Personen beim Auslandskrankenschutz, Werte: None = 0; Mitglied = 1; Partner = 2; Kind = 3; Sonstige = 4; 
 */
export enum PersonenAksApi {
	None = 0,  // None
	Mitglied = 1,  // Mitglied
	Partner = 2,  // Partner
	Kind = 3,  // Kind
	Sonstige = 4  // Sonstige
};